import { defineStore } from 'pinia'
// import { useFormStore  } from '@/stores/form'
// import { useLanguageStore } from '@/stores/language'

// import axios from "axios"


export const useConfigStore = defineStore('config', {
    state: () => ({
        editURL: "",
        redirect: "",
        cmd: "",
        editMode: "component",
        editingPaths: false,
        namespace: "",
        isDraft: true,
        workflowAction: 2,
        translations: ['fi','sv','en'],
        availableLocales: ["fi_FI","sv_SE","en_US"],
        components: ['radio','checkbox','textarea', 'button', 'choices', 'doneByDefault'],
        stageTypes: ['text','text-image','image'],
        activeNode: null,
        isLoading: true,
        isPanning: true,
        pathDefaultColors: ["#3366cc","#dc3912","#ff9900","#109618","#990099","#0099c6","#dd4477","#66aa00","#b82e2e","#316395","#994499","#22aa99","#aaaa11","#6633cc","#e67300","#8b0707","#651067","#329262","#5574a6","#3b3eac","#b77322","#16d620","#b91383","#f4359e","#9c5935","#a9c413","#2a778d","#668d1c","#bea413","#0c5922","#743411"],
        viewbox: {
            zoom: null,
            pan: {
                x: null,
                y: null
            }
        },
        showNodeName: true,
        editableNodes: [],
        selectedEditableNode: false
    }),
    getters: {
        getSurveyId: (state) => state.surveyId,
        getEditUrl: (state) => state.editURL,
        getRedirectURL: (state) => state.redirect,
        getSelectImage: (state) => state.selectImage,
        getPathColors: (state) => state.pathDefaultColors,
        getPathColorByIndex: (state) => {
            return (idx) => state.pathDefaultColors[idx]
        },
        getNameSpace: (state) => state.namespace,
        getComponents: (state) => state.components,
        getStageTypes: (state) => state.stageTypes,
        getIsPanning: (state) => state.isPanning,
        getViewbox: (state) => state.viewbox,
        getEditingPaths: (state) => state.editingPaths,
        getShowNodeName: (state) => state.showNodeName,
        getEditableNodes: (state) => state.editableNodes,
        getSelectedEditableNode: (state) => state.selectedEditableNode
    },
    actions: {
        async getSurveyFormData(url) {
            // const languageStore = useLanguageStore()
            // const formStore = useFormStore()

            // try {
            //     const surveyApp = await axios.get(url)
            //     if (surveyApp.data) {
            //         const survey = surveyApp.data
            //         // Set config data
            //         this.editURL = survey.editSurveyURL
            //         this.namespace = survey.namespace
            //         this.isDraft = survey.isDraft
            //         this.workflowAction = this.isDraft === false ? 1 : 2

            //         // Set usable languages
            //         // languageStore.setAllLanguages(survey.availableLocales)
            //         // Set form data
            //         // formStore.setTitle(survey.title)
            //         // formStore.setSurveyId(survey.surveyId)
            //         // formStore.setStages(survey.data)


            //         this.isLoading = false
            //     }
            // } catch(error) {
            //     console.log('oops, something went wrong...', error)
            // }
        },
        setRedirectUrl(url) {
            this.redirect = url
        },
        setSelectImage(selectImage) {
            this.selectImage = selectImage
        },
        setActiveNode(id) {
            this.activeNode = id
        },
        setPanState(paylod) {
            this.isPanning = paylod
        },
        setNewPan(payload){
            this.viewbox.pan.x = payload.x
            this.viewbox.pan.y = payload.y
        },
        setNewZoom(payload) {
            this.viewbox.zoom = payload
        },
        setEditPath(state) {
            this.editingPaths = state
        },
        toggleShowNodeName(state) {
            this.showNodeName = state
        },
        setEditableNodes(payload) {
            this.editableNodes = payload
        },
        toggleSelectedEditableNode(payload) {
            this.selectedEditableNode = payload
        }

    }
})